module.exports = __webpack_public_path__ + "static/img/menu-offer.b0f5931.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-img/png-img/menu-offer.png
// module id = 1359
// module chunks = 4